import { RPM_DEVICE_OPTIONS } from "../static/constants";

export const getRpmDeviceKeyFromValue = (rpmDeviceName) => {
  const rpmInfo = RPM_DEVICE_OPTIONS.find((rpm) => rpm.value === rpmDeviceName);
  return rpmInfo?.key;
};

export const getRpmDeviceValueFromKey = (rpmDeviceKey) => {
  const rpmInfo = RPM_DEVICE_OPTIONS.find((rpm) => rpm.key === rpmDeviceKey);
  return rpmInfo?.value;
};

export const checkIsRpmManufacturer = (manufacturer) => {
  const isRpm = RPM_DEVICE_OPTIONS.some((rpm) => rpm.value === manufacturer);
  return !!isRpm;
};

export const filterRpmManufacturers = (manufacturers) => {
  const manufacturerList = [...new Set(manufacturers)];

  const filteredManufacturers = manufacturerList?.filter((manufacturer) =>
    checkIsRpmManufacturer(manufacturer)
  );

  return filteredManufacturers;
};

export const checkHasMultipleRpmManufacturers = (manufacturers) => {
  return filterRpmManufacturers(manufacturers)?.length > 1;
};
